
import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';


export const getCompany = catchAsync(async (name) => {
    const { data } = await axiosInstance.get(
        `/api/resource/Company/${name}`
    );
    return data;
});
export const updateCompany = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Company/${id}`,
    body
  );
  return data;
});